/**
 * Uses the meta data of AutoEncoder to check if something is a patch or a put
 */
export class PatchOrPutDecoder {
    putDecoder;
    patchDecoder;
    constructor(put, patch) {
        this.putDecoder = put;
        this.patchDecoder = patch;
    }
    decode(data) {
        const isPatch = data.optionalField('_isPatch');
        if (isPatch?.boolean ?? false) {
            return this.patchDecoder.decode(data);
        }
        return this.putDecoder.decode(data);
    }
    isDefaultValue(value) {
        return this.patchDecoder.isDefaultValue ? this.patchDecoder.isDefaultValue(value) : false;
    }
    getDefaultValue() {
        return this.patchDecoder.getDefaultValue ? this.patchDecoder.getDefaultValue() : undefined;
    }
}
//# sourceMappingURL=PatchOrPutDecoder.js.map